import { type CreateBlockData } from '@/lib/builder/types'

import {
  type CardsSection,
  type CardsSectionCreate,
} from '../../../WebsiteBuilder.types'

export const createCardsData = ({
  brandId,
}: CreateBlockData<CardsSection>): CardsSectionCreate => ({
  brandId,
  params: {
    cards: [
      {
        buttonLabel: null,
        description: null,
        image: null,
        link: null,
        subtitle: null,
        title: 'Card Title',
      },
      {
        buttonLabel: null,
        description: null,
        image: null,
        link: null,
        subtitle: null,
        title: 'Card Title',
      },
      {
        buttonLabel: null,
        description: null,
        image: null,
        link: null,
        subtitle: null,
        title: 'Card Title',
      },
    ],
    title: 'Our Offerings',
  },
  type: 'cards',
})
